module.exports = __webpack_public_path__ + "static/media/facebook-link.fc76e22a.svg";